module.exports = __webpack_public_path__ + "img/icon-dados.35ef00d1.svg";